import React from "react";
import { Star, Leaf, Truck, ShieldCheck } from "lucide-react";
import { TRUST_POINTS } from "../../lib/constants";

const ICONS = { Star, Leaf, Truck, ShieldCheck };

export const TrustBar = () => {
  const items = [...TRUST_POINTS, ...TRUST_POINTS];
  return (
    <section className="border-y border-black/10 bg-ink text-white overflow-hidden" data-testid="trust-bar">
      <div className="flex items-center whitespace-nowrap animate-marquee py-5">
        {items.map((it, i) => {
          const Icon = ICONS[it.icon] || Star;
          return (
            <div key={i} className="flex items-center gap-3 px-10 text-[12px] uppercase tracking-[0.25em] text-white/85">
              <Icon size={14} className="text-brand" />
              {it.text}
              <span className="text-brand ml-8">◆</span>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default TrustBar;
